if (window.location.pathname.includes("/products/")) {
  const getText = (el) => (el?.textContent || "").trim();

  const updateMainPrice = (ioPriceRoot) => {
    if (!ioPriceRoot) return;

    const getTextSafe = (el) => (el ? (el.textContent || "").trim() : "");
    const parseMoney = (str) => {
      if (!str) return NaN;
      // keep digits and decimal point (handles $1,234.56 or 1,234.56)
      const n = str.replace(/[^0-9.]/g, "");
      return n ? parseFloat(n) : NaN;
    };
    const formatMoney = (num) =>
      new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: "USD",
      }).format(num);

    const priceEl = ioPriceRoot.querySelector(
      "span.price-item.price-item--regular"
    );
    const rawPriceText = getTextSafe(priceEl) || getTextSafe(ioPriceRoot);

    const jsValueSpan = document.querySelector(
      ".product-info .price-container span.price__current .js-value"
    );
    if (jsValueSpan && rawPriceText) {
      jsValueSpan.style.display = "none";

      if (jsValueSpan.parentElement.querySelector(".infinite-value")) {
        jsValueSpan.parentElement.querySelector(".infinite-value").remove();
      }
      const item = document.createElement("span");
      item.className = "infinite-value";
      item.textContent = rawPriceText;
      jsValueSpan.parentElement.insertBefore(
        item,
        jsValueSpan.parentElement.firstChild
      );
    }

    const labelElement = document.querySelector(".spb-label-tooltip");
    if (!labelElement) return;

    // Extract just the label text (including ⓘ but not the tooltip description)
    let baseLabel = labelElement.dataset.baseText;
    if (!baseLabel) {
      // Get text content and extract only the part before the tooltip description
      const fullText = labelElement.textContent || "";
      // The format is: "Label Nameⓘ[long tooltip description]"
      // We want to keep "Label Nameⓘ" but remove the description after it
      const match = fullText.match(/^(.*?ⓘ)/);
      if (match) {
        baseLabel = match[1].trim();
      } else {
        // Fallback if no ⓘ found
        baseLabel = fullText.split(".")[0].trim();
      }
      labelElement.dataset.baseText = baseLabel;
    }

    const infiniteOptionPriceNum = parseMoney(rawPriceText);
    const productPriceNum = parseMoney(getTextSafe(jsValueSpan));

    if (!isFinite(infiniteOptionPriceNum) || !isFinite(productPriceNum)) {
      labelElement.textContent = baseLabel;
      return;
    }

    const diffCents = Math.round(
      (infiniteOptionPriceNum - productPriceNum) * 100
    );
    const diff = diffCents / 100;

    const text =
      diffCents === 0
        ? "Included"
        : `${diff > 0 ? "+" : "-"}${formatMoney(Math.abs(diff))}`;

    const compareAtPrice = document.querySelector(
      ".product-info .price-container .price__was .js-value"
    );

    if (compareAtPrice) {
      compareAtPrice.style.display = "none";
      const currentValue =
        parseFloat(compareAtPrice.textContent.replace(/[^0-9.]/g, "")) || 0;
      if (currentValue != 0) {
        const newValue = currentValue + diff;

        if (compareAtPrice.parentElement.querySelector(".infinite-value")) {
          compareAtPrice.parentElement
            .querySelector(".infinite-value")
            .remove();
        }
        const item = document.createElement("span");
        item.className = "infinite-value";
        item.textContent = formatMoney(newValue.toFixed(2));
        compareAtPrice.parentElement.insertBefore(
          item,
          compareAtPrice.parentElement.firstChild
        );
      }
    }

    const container = document.querySelector("#infiniteoptions-container");
    if (!container) return;

    const selected = container.querySelector("input:checked").value;

    // Preserve the original structure and only update the text content
    // Don't use innerHTML as it destroys the interactive tooltip elements
    if (selected) {
      // Find or create the selected value span
      let valueSpan = labelElement.querySelector(".infinite-selected-value");
      if (!valueSpan) {
        // Create the value span if it doesn't exist
        valueSpan = document.createElement("span");
        valueSpan.className = "infinite-selected-value";
        labelElement.appendChild(document.createTextNode(": "));
        labelElement.appendChild(valueSpan);
      }
      valueSpan.textContent = selected;
    } else {
      // Remove the selected value if nothing is selected
      const valueSpan = labelElement.querySelector(".infinite-selected-value");
      if (valueSpan) {
        // Remove the ": " text node before the span as well
        const prevNode = valueSpan.previousSibling;
        if (
          prevNode &&
          prevNode.nodeType === Node.TEXT_NODE &&
          prevNode.textContent === ": "
        ) {
          prevNode.remove();
        }
        valueSpan.remove();
      }
    }

    let span = container.querySelector(".infinite_description");
    if (!span) {
      span = document.createElement("span");
      span.className = "infinite_description";
      container.appendChild(span);
    }

    span.textContent = text;
  };

  const observer = new MutationObserver(() => {
    // Try class; if your theme uses a custom element or id, add fallbacks here
    const infiniteOptionsPrice = document.querySelector(
      ".infiniteoptions-price"
    );
    const infiniteOptionsContainer = document.querySelector(
      "#infiniteoptions-container"
    );
    const infiniteLabel = document.querySelector(
      "#infiniteoptions-container .spb-label-tooltip"
    );

    if (!infiniteOptionsPrice || !infiniteOptionsContainer || !infiniteLabel)
      return;

    // Initial price sync
    updateMainPrice(infiniteOptionsPrice);

    // Event delegation: handle any radio/checkbox changes inside the container
    const onChange = (e) => {
      const t = e.target;
      if (
        t &&
        (t.matches('input[type="radio"]') ||
          t.matches('input[type="checkbox"]'))
      ) {
        if (t.checked) {
          updateMainPrice(infiniteOptionsPrice);
        }
      }
    };

    // Attach once
    infiniteOptionsContainer.addEventListener("change", onChange);

    // Stop the outer observer; we’re wired up now
    observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Failsafe: disconnect after 10s
  setTimeout(() => observer.disconnect(), 10000);
}
